import { useState } from "react";
import {v4 as uuidv4} from 'uuid';

export function useUuid() {
    let [uuid, setUuid] = useState(uuidv4());
    // let [uuid, setUuid] = useState("hello");

    let resetUuid = () => { setUuid(uuidv4); };
    return {uuid, resetUuid};
}